import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { getStorageItem, setStorageItem } from 'CorePackage/MainModule/common/localStore';

import { IKnmListFilterState } from '../interfaces/IKnmListFilterState';
import { KnmListFilterAction } from '../types/KnmListFilterAction';
import { KnmListFilterActionsEnum } from '../enums/KnmListFilterActionsEnum';
import { IKnmListFilterWithMeta } from '../interfaces/IKnmListFilterWithMeta';

const initialState: IKnmListFilterState = {
  current: getStorageItem(StorageNamesEnum.KNM_FILTER),
  isFilterOn: !!getStorageItem(StorageNamesEnum.KNM_FILTER_ON),
  filters: [],
  currentControlOrganizations: [],
};

export function knmListFilterReducer(state = initialState, action: KnmListFilterAction) {
  switch (action.type) {
    case KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_CURRENT: {
      const { current, currentId } = action.payload;
      const newState: IKnmListFilterState = {
        ...state,
        current,
        currentId,
      };

      setStorageItem(StorageNamesEnum.KNM_FILTER, current);

      return newState;
    }
    case KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_SWITCHER: {
      const { value: isFilterOn } = action.payload;
      const newState: IKnmListFilterState = {
        ...state,
        isFilterOn,
      };

      setStorageItem(StorageNamesEnum.KNM_FILTER_ON, isFilterOn);

      return newState;
    }
    case KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_PLAN_NUM: {
      const { planNum } = action.payload;
      const newState: IKnmListFilterState = {
        ...state,
        planNum,
      };

      return newState;
    }
    case KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_META: {
      const filters = action.payload.list.map<IKnmListFilterWithMeta>(meta => ({ meta }));
      const newState: IKnmListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    case KnmListFilterActionsEnum.KNM_LIST_FILTER_REMOVE: {
      const { id } = action.payload;
      const filters = state.filters.filter(f => f.meta.id !== id);
      const newState: IKnmListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    case KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_DATA: {
      const { id, data } = action.payload;
      const filters = state.filters.map<IKnmListFilterWithMeta>(filter => {
        if (filter.meta.id === id) {
          return {
            ...filter,
            data,
            meta: {
              ...filter.meta,
              id,
              name: data.name,
            },
          };
        }

        return filter;
      });
      const newState: IKnmListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    case KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_CURRENT_CONTROL_ORGANIZATIONS: {
      const { ids } = action.payload;
      const newState: IKnmListFilterState = {
        ...state,
        currentControlOrganizations: ids,
      };

      return newState;
    }

    case KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_CURRENT_FEDERAL_LAWS: {
      const { federalLaws } = action.payload;
      const newState: IKnmListFilterState = {
        ...state,
        federalLaws,
      };

      return newState;
    }
    default:
      return state;
  }
}
